export const OFFICE_ADDRESS = "Puck van Heelstraat 142, 3077 MG Rotterdam, Netherlands";
export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(OFFICE_ADDRESS)}`;
